import React, { useState } from 'react'

import { Card, Typography } from 'antd'

import { EibFilter } from './EibFilter'
import { EibBigNumbers } from './EibBigNumbers'
import { EibActionsByCategory } from './EibActionsByCategory'
import { EibPlannedActions } from './EibPlannedActions'
import { EibExecutedActions } from './EibExecutedActions'
import { EibList } from './EibList'
import EmptyData from '../../../assets/images/ico_dashboard.svg'
import './styles.css'

export const EibDashboard = () => {
  const [filter, setFilter] = useState({})

  return (
    <>
      <EibFilter filter={filter} setFilter={setFilter} />
      {Object.values(filter).length !== 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
            <Card className="ant-card gx-card ant-card-bordered" style={{ width: '49%' }}>
              <EibBigNumbers filter={filter} />
            </Card>
            <Card className="ant-card gx-card ant-card-bordered" style={{ width: '49%' }}>
              <EibActionsByCategory filter={filter} />
            </Card>
          </div>
          <div>
            <Card className="ant-card gx-card ant-card-bordered" style={{ height: '85%', width: '100%' }}>
              <EibPlannedActions filter={filter} />
            </Card>
          </div>
          <div>
            <Card className="ant-card gx-card ant-card-bordered" style={{ height: '85%', width: '100%' }}>
              <EibExecutedActions filter={filter} />
            </Card>
          </div>
          <div>
            <EibList filter={filter} />
          </div>
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: 310, background: '#F1F3F5' }}>
            <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
            <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18 }}>
              {'Sem dados'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -50 }}
            >
              {'Aplique ou altere o filtro para'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -120 }}
            >
              {'exibir dados.'}
            </Typography>
          </div>
        </div>
      )}
    </>
  )
}
